module.exports = __webpack_public_path__ + "img/21.477d1d49.png";